"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _utils = require("../utils");
var _analyticsUtils = require("../utils/analyticsUtils");
var _constants = require("../constants");
var _staticContent = require("../staticContent");
var _errorHandlerUtility = _interopRequireDefault(require("../utils/errorHandlerUtility"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function useSubmitForm(fieldValues, userGaveConsent, consentField, consentRef, formMetaData, onSubmit, setError, isProduction, fieldReferences, language, fieldData, accessConfig, usePreviewAPI, validationApiConfig, setErrorApiValidationMessage) {
  var {
    headers,
    path,
    method = 'POST',
    expectedResponseStatusValidationObject,
    body
  } = validationApiConfig;
  var [hasSubmitted, setHasSubmitted] = (0, _react.useState)(false);
  var [clickedSubmit, setClickedSubmit] = (0, _react.useState)(false);
  var [readyForSubmission, setReadyForSubmission] = (0, _react.useState)(false);
  var [backendErrored, setBackendErrored] = (0, _react.useState)(false);
  var [submissionID, setSubmissionID] = (0, _react.useState)('');
  var isFieldGroup = field => field.type === _constants.FIELD_TYPES.FIELD_GROUP_FIELD;
  var isRichTextField = field => field.type === _constants.FIELD_TYPES.RICH_TEXT_FIELD;
  var isStepTracker = field => field.type === _constants.FIELD_TYPES.STEP_TRACKER_FIELD;
  var isConsentField = field => field.type === _constants.FIELD_TYPES.CONSENT_FIELD;
  var isLongAnswerField = field => field.type === _constants.FIELD_TYPES.LONGANSWER_FIELD;
  var isFileUploadField = field => field.type === _constants.FIELD_TYPES.FILE_UPLOAD_FIELD;
  var fileName = 'useSubmitForm.jsx';

  // use setError callback
  // instead of return boolean, return object with error message
  var callValidationApi = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (path, options, expectedResponseStatusValidationObject) {
      try {
        var _apiResponse$status, _expectedResponseValu, _expectedResponseValu2;
        var {
          body: _body,
          headers: _headers,
          method: _method
        } = options;
        var apiResponse = yield (0, _utils.makeHTTPRequest)(_body, '', isProduction, accessConfig, path, _method, [], _headers);
        var responseCode = (_apiResponse$status = apiResponse.status) !== null && _apiResponse$status !== void 0 ? _apiResponse$status : null;
        var {
          expectedStatusCode,
          expectedResponseValueObject
        } = expectedResponseStatusValidationObject;
        var expectedResponseValuePath = (_expectedResponseValu = expectedResponseValueObject.path) !== null && _expectedResponseValu !== void 0 ? _expectedResponseValu : null;
        var expectedResponseValueValue = (_expectedResponseValu2 = expectedResponseValueObject.value) !== null && _expectedResponseValu2 !== void 0 ? _expectedResponseValu2 : null;
        var apiData = yield apiResponse.json();
        var responseValue = (0, _utils.getValueByDotNotation)(apiData, expectedResponseValuePath);
        var responseHasError = (() => {
          if (expectedStatusCode && expectedResponseValueValue) {
            if (responseCode !== expectedStatusCode || responseValue !== expectedResponseValueValue) return true;
            return false;
          }
          return false;
        })();
        if (responseHasError) {
          var errorMessage = validationApiConfig.errorResponsePath === null ? 'Error' : (0, _utils.getValueByDotNotation)(apiData, validationApiConfig.errorResponsePath);
          setErrorApiValidationMessage(errorMessage);
          return false;
        }
        setErrorApiValidationMessage(undefined);
        return true;
      } catch (error) {
        _errorHandlerUtility.default.report(JSON.stringify({
          isProduction: isProduction,
          language: language,
          message: "callValidationApi - ".concat(error),
          fileName,
          methodName: 'callValidationApi'
        }));
      }
    });
    return function callValidationApi(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var apiValidation = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      // Checks to see if the submitted fieldValues include all the dynamic values required in the validationApiConfig
      var dynamicFieldValues = (0, _utils.checkDynamicValues)(validationApiConfig.body, fieldValues);
      if (dynamicFieldValues) {
        var options = {
          headers,
          method,
          body: JSON.stringify((0, _utils.createNestedObject)(body, fieldValues))
        };
        try {
          var response = yield callValidationApi(path, options, expectedResponseStatusValidationObject);
          return response;
        } catch (error) {
          _errorHandlerUtility.default.report(JSON.stringify({
            isProduction: isProduction,
            language: language,
            message: "apiValidation - ".concat(error),
            fileName,
            methodName: 'apiValidation'
          }));
        }
      } else return true;
    });
    return function apiValidation() {
      return _ref2.apply(this, arguments);
    };
  }();
  var submitForm = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(function* () {
    var _payload$fields, _payload$fields2;
    var errorMessages = [];
    var isFormFieldsValid = () => {
      var _loop = function _loop(id) {
          // Skip validation for hidden fields
          if (fieldData.current[id].isHidden) {
            return 0; // continue
          }

          // Only validate visible fields
          if (!fieldData.current[id].isValid) {
            var _formMetaData$fields;
            var _fieldValues = formMetaData === null || formMetaData === void 0 || (_formMetaData$fields = formMetaData.fields) === null || _formMetaData$fields === void 0 ? void 0 : _formMetaData$fields.find(field => field.id === id);
            errorMessages.push("".concat((_fieldValues === null || _fieldValues === void 0 ? void 0 : _fieldValues.label) || 'Field', "_is_invalid_or_empty"));
            return {
              v: false
            };
          }
        },
        _ret;
      for (var id in fieldData.current) {
        _ret = _loop(id);
        if (_ret === 0) continue;
        if (_ret) return _ret.v;
      }
      if (errorMessages.length > 0) {
        (0, _analyticsUtils.triggerAnalyticsErrorEvent)(formMetaData, _constants.ANALYTICS_ERROR_TYPES.FIELD_COMPLETION, errorMessages.join(', '));
        return false;
      }
      return userGaveConsent || consentField === undefined ? true : false;
    };
    var isFormApiValidationValid = validationApiConfig.path ? yield apiValidation() : true;
    var isFormValid = () => isFormFieldsValid() && isFormApiValidationValid;
    setClickedSubmit(true);

    // Clone the payload and add the field values to each field meta data entry
    var payload = Object.assign({}, formMetaData, {
      metadata: (0, _utils.getMetaData)()
    });
    // Adding usePreviewAPI to the payload
    payload.usePreviewAPI = usePreviewAPI || false;
    // Reconstruct a flattened view of the fields by adding child fields of FieldGroup to payload
    payload.fields = [];
    var stepTrackerConsentField = [];
    var preparePayload = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* () {
        formMetaData.fields.forEach(field => {
          if (isFieldGroup(field) && field.fields && Array.isArray(field.fields)) {
            field.fields.forEach(childField => {
              // Even though we are flattening the field structure (i.e: removing field groups)
              // We should still keep reference of the field group in field as its parent
              // Note: there is NO nesting (field group within field group) for additional complexity

              if (!isRichTextField(childField)) {
                var fieldClone = Object.assign({}, field);
                delete fieldClone.fields;
                payload.fields.push(Object.assign(childField, {
                  parent: fieldClone
                }));
              }
            });
          } else if (field.isConditionalField) {
            // If field is a conditional field add the data that is not hidden to the payload
            field.options.forEach(option => {
              var _option$conditionalFi;
              (_option$conditionalFi = option.conditionalFieldGroup) === null || _option$conditionalFi === void 0 || _option$conditionalFi.fields.forEach(childField => {
                if (fieldData.current[childField.id]) {
                  var fieldClone = Object.assign({}, option.conditionalFieldGroup);
                  delete fieldClone.fields;
                  if (!fieldData.current[childField.id].isHidden) {
                    payload.fields.push(Object.assign(childField, {
                      parent: fieldClone
                    }));
                  }
                }
              });
            });
            // Add the top level conditional field data to the payload
            payload.fields.push(field);
          } else if (isStepTracker(field) && field.steps && Array.isArray(field.steps)) {
            field.steps.forEach((step, stepIndex) => {
              if (step.fields && Array.isArray(step.fields)) {
                step.fields.forEach((stepField, stepFieldIndex) => {
                  if (isFieldGroup(stepField) && stepField.fields && Array.isArray(stepField.fields)) {
                    // Field Group
                    stepField.fields.forEach(childField => {
                      if (!isRichTextField(childField)) {
                        var fieldClone = Object.assign({}, stepField);
                        delete fieldClone.fields;
                        payload.fields.push(Object.assign(childField, {
                          parent: fieldClone
                        }));
                      }
                    });
                  } else if (stepField.isConditionalField) {
                    // Conditional Field
                    stepField.options.forEach(option => {
                      var _option$conditionalFi2;
                      (_option$conditionalFi2 = option.conditionalFieldGroup) === null || _option$conditionalFi2 === void 0 || _option$conditionalFi2.fields.forEach(childField => {
                        if (fieldData.current[childField.id]) {
                          var fieldClone = Object.assign({}, option.conditionalFieldGroup);
                          delete fieldClone.fields;
                          if (!fieldData.current[childField.id].isHidden) {
                            payload.fields.push(Object.assign(childField, {
                              parent: fieldClone
                            }));
                          }
                        }
                      });
                    });
                    // Add the top level conditional field data to the payload
                    payload.fields.push(stepField);
                  } else if (isConsentField(stepField)) {
                    var _stepTrackerConsentFi, _stepTrackerConsentFi2;
                    if (Array.isArray(stepTrackerConsentField) && stepTrackerConsentField.length === 0) {
                      stepTrackerConsentField.push(stepField);
                    } else if ((_stepTrackerConsentFi = stepTrackerConsentField[0]) !== null && _stepTrackerConsentFi !== void 0 && _stepTrackerConsentFi.consentOptions && Array.isArray(stepTrackerConsentField[0].consentOptions) && stepField !== null && stepField !== void 0 && stepField.consentOptions && Array.isArray(stepField.consentOptions)) {
                      stepTrackerConsentField[0].consentOptions = [...stepTrackerConsentField[0].consentOptions, ...(stepField === null || stepField === void 0 ? void 0 : stepField.consentOptions)];
                    }
                    stepTrackerConsentField[0].isReadOnly = ((_stepTrackerConsentFi2 = stepTrackerConsentField[0]) === null || _stepTrackerConsentFi2 === void 0 ? void 0 : _stepTrackerConsentFi2.isReadOnly) && ((stepField === null || stepField === void 0 ? void 0 : stepField.isReadOnly) || false);
                  } else if (!isRichTextField(stepField)) {
                    payload.fields.push(stepField);
                  }
                });
              }
            });
          } else if (!isRichTextField(field)) {
            // If field is a regular field (not Field Group and not Conditional Field, add to payload)
            payload.fields.push(field);
          }
        });
        Object.keys(fieldData.current).forEach(fieldID => {
          var field = payload.fields.find(fieldObj => fieldObj.id === fieldID);
          if (field) {
            field.value = fieldValues[fieldID];
          }
        });
        if (formMetaData.enableRecaptcha) {
          try {
            var recaptchaToken = yield window.grecaptcha.execute((0, _utils.getRecaptchaKey)(isProduction, formMetaData), {
              action: 'submit'
            });
            // Add recaptcha information to payload
            payload.recaptchaToken = recaptchaToken;
            payload.isRecaptchaEnabled = formMetaData.enableRecaptcha;
          } catch (error) {
            var errorMsg = _staticContent.FORM_COMPONENT.UNSUCCESSFUL_MESSAGE[language];
            setError(errorMsg);
            (0, _analyticsUtils.triggerAnalyticsErrorEvent)(formMetaData, _constants.ANALYTICS_ERROR_TYPES.SUBMISSION, errorMsg);
            _errorHandlerUtility.default.report(JSON.stringify({
              isProduction: isProduction,
              language: language,
              message: errorMsg,
              fileName,
              methodName: 'submitForm-preparePayload'
            }));
          }
        }

        // Setting form fields as valid or not
        var firstInvalidID;
        payload.fields.forEach(field => {
          if (!fieldData.current[field.id].isValid && firstInvalidID === undefined) {
            firstInvalidID = field.id;
          }
        });

        // if there an invalid field, set the focus on it
        if (firstInvalidID !== undefined) {
          var inputElement = fieldReferences[firstInvalidID].current;
          if (inputElement) {
            inputElement.scrollIntoView();
          }
        } else if (consentField !== undefined && !userGaveConsent) {
          // If there are no invalid fields, then check if the consent is invalid
          // and if so, set focus to the checkbox
          if (consentRef.current) {
            consentRef.current.scrollIntoView();
          }
        }

        // Add the user's consent selection to the payload if it's required
        if (Array.isArray(stepTrackerConsentField) && stepTrackerConsentField.length > 0) {
          payload.consentField = stepTrackerConsentField[0];
          payload.userGaveConsent = true;
        } else {
          // Add the user's consent selection to the payload (even if it's not required)
          payload.userGaveConsent = userGaveConsent;
        }
      });
      return function preparePayload() {
        return _ref4.apply(this, arguments);
      };
    }();
    yield preparePayload();

    // Short-circuit if the form is invalid in any way
    if (!isFormValid()) {
      return;
    }

    // Update the state to indicate the submission is ready
    // which is used to show the spinner and hide the submit button
    setReadyForSubmission(true);

    // Given the async nature of setState, it's better to use a separate var than backendErrored
    // This is for the frontend to consume the fact that backend (adapters specifically) failed
    var backendSuccessful = true;
    // Send the form data to the backend

    //! Look for JSON editor fields and replace placeholders if present
    //! if not body is present, default object will be sent
    payload === null || payload === void 0 || (_payload$fields = payload.fields) === null || _payload$fields === void 0 || _payload$fields.forEach(field => {
      if ((field === null || field === void 0 ? void 0 : field.type) === _constants.FIELD_TYPES.ADDRESS_FIELD && field !== null && field !== void 0 && field.body && (0, _utils.isNotEmptyObject)(field === null || field === void 0 ? void 0 : field.body)) {
        var _copyValues$value, _copyValues$body;
        var copyValues = _objectSpread({}, field);
        var parsedValues = JSON.parse((_copyValues$value = copyValues === null || copyValues === void 0 ? void 0 : copyValues.value) !== null && _copyValues$value !== void 0 ? _copyValues$value : {});
        var bodyJsonEditor = (_copyValues$body = copyValues === null || copyValues === void 0 ? void 0 : copyValues.body) !== null && _copyValues$body !== void 0 ? _copyValues$body : {};
        var result = (0, _utils.replacePlaceHolders)(bodyJsonEditor, parsedValues);
        field.value = result;
      }
    });
    var files = [];
    payload === null || payload === void 0 || (_payload$fields2 = payload.fields) === null || _payload$fields2 === void 0 || _payload$fields2.forEach(field => {
      if (isFileUploadField(field)) {
        if (field.value.length > 0) {
          // add the binary files to the files array
          files.push(...field.value);
          // transform the array of binary files to an array of objects with file metadata
          field.value = field.value.map(file => ({
            name: file.name,
            type: file.type,
            size: file.size
          }));
        }
      }
      if (isLongAnswerField(field) && typeof field.value === 'string' && field.value.trim().length > 0) {
        field.value = (0, _utils.sanitizeValue)(field.value);
      }
    });
    (0, _utils.makeHTTPRequest)(JSON.stringify(payload), '', isProduction, accessConfig, '', _constants.HTTP_POST, files).then(response => {
      // Convert a 400-series status to an error 500-series will be thrown automatically
      if (response.status >= 400) {
        setBackendErrored(true);
        backendSuccessful = false;
      }
      setHasSubmitted(true);
      return response.json();
    }).then(responseJSON => {
      // As requested by Analytics, send submissionID towards dataLayer/Adobe analytics
      // for association/lookup in the backend systems
      // It was recommended by analytics team to do collect the submissionID via datalayer
      // regardless of backend response (in this case, "backendSuccessful")
      if (responseJSON.submissionID) {
        setSubmissionID(responseJSON.submissionID);
        if (window && window.dataLayer) {
          window.dataLayer.event = Object.assign({
            formSubmissionId: responseJSON.submissionID
          }, window.dataLayer.event);
        }
        var {
          adapterResponseArray
        } = responseJSON;
        (0, _analyticsUtils.triggerAnalyticsFormComplete)(payload, responseJSON.submissionID, adapterResponseArray);

        // Extract all downloadable files from adapter responses
        var filesToDownload = Array.isArray(adapterResponseArray) ? adapterResponseArray.reduce((accFiles, response) => {
          var _response$files;
          if ((response === null || response === void 0 || (_response$files = response.files) === null || _response$files === void 0 ? void 0 : _response$files.length) > 0) {
            return [...accFiles, ...response.files];
          }
          return accFiles;
        }, []) : [];

        // download files if any
        filesToDownload.forEach(file => {
          try {
            if (!file.data || !file.fileName) {
              console.error('Invalid file data:', file);
              return;
            }
            var byteArray = new Uint8Array(file.data);
            var blob = new Blob([byteArray], {
              type: file.mimeType
            });
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = file.fileName;
            document.body.appendChild(a);
            a.click();

            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          } catch (error) {
            console.error('Error downloading file:', error, file);
          }
        });
      }
    }).catch(error => {
      var errorMessage = typeof error === 'object' ? error.message : error;
      var errorCode = typeof error === 'object' ? error.code : '';
      setError(errorMessage);
      (0, _analyticsUtils.triggerAnalyticsErrorEvent)(formMetaData, _constants.ANALYTICS_ERROR_TYPES.SUBMISSION, errorMessage, errorCode);
      _errorHandlerUtility.default.report(JSON.stringify({
        isProduction: isProduction,
        language: language,
        message: errorMessage,
        fileName,
        methodName: 'submitForm'
      }));
    }).finally(() => {
      if (backendErrored) {
        (0, _analyticsUtils.triggerAnalyticsErrorEvent)(formMetaData, _constants.ANALYTICS_ERROR_TYPES.SUBMISSION, payload.unsuccessfulSubmissionMessage);
      }
      if (typeof onSubmit === 'function') {
        onSubmit(_objectSpread(_objectSpread({}, payload), {}, {
          isFormValid,
          backendSuccessful
        }));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [consentField, consentRef, fieldData, fieldReferences, fieldValues, formMetaData, isProduction, language, onSubmit, setError, userGaveConsent]);
  return {
    submitForm,
    clickedSubmit,
    readyForSubmission,
    hasSubmitted,
    backendErrored,
    submissionID
  };
}
var _default = exports.default = useSubmitForm;